export default __webpack_public_path__ + "static/guidestar-bef85e88de9455f0477023fc8e0d7d18.svg";